import { render } from "./transformation-projects.vue?vue&type=template&id=e976665e&scoped=true"
import script from "./transformation-projects.vue?vue&type=script&lang=js"
export * from "./transformation-projects.vue?vue&type=script&lang=js"

import "./transformation-projects.vue?vue&type=style&index=0&id=e976665e&lang=scss"
import "./transformation-projects.vue?vue&type=style&index=1&id=e976665e&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e976665e"]])

export default __exports__